// @flow
import firestore from '../services/firestore';
import messageSchema from '../../server/shared/schemas/message';

export default messageSchema(firestore);